import { put,takeLatest } from 'redux-saga/effects';

import MyFavoritesService from '../../../services/MyFavorites.service';
import {
  DELETE_FAVORITE,
  ERROR_DELETE_FAVORITE,
  SUCESS_DELETE_FAVORITE} from '../../constants';

function* deleteFavorite(action) {
  try {
    yield MyFavoritesService.delete(action.params);
    yield put({
      type: SUCESS_DELETE_FAVORITE
    });
  } catch (error) {
    yield put({ type: ERROR_DELETE_FAVORITE, error });
  }
}

function* deleteFavoriteSagas() {
  yield takeLatest(DELETE_FAVORITE, deleteFavorite);
}

export default deleteFavoriteSagas;
